<template>
  <div class="url field">
    <label for="name">{{ fieldConfig.label || fieldConfig.name }}</label>
    <div>
      <input
          type="text"
          name="name"
          :value="fieldValue || fieldConfig.defaultValue"
          @keyup="onKey"
      >
      <div
          class="complaint"
          v-for="(error, index) in complaints"
          :key="index"
      >
        <span class="error">{{error}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import JsonFieldMixin from '../../mixins/documentCollections/json/JsonFieldMixin'
  export default {
    name: "vJsonUrlField",
    mixins: [
      JsonFieldMixin
    ],
    data() {
      return {
        checks: [
          {
            validator: (val) => val.trim().match(/\s/) === null,
            complaint: 'url cannot contain whitespace characters'
          },
          {
            validator: (val) => val.trim().match(/^https?:\/\/[^\s]+(?:\.[^\s.]+)$/) !== null,
            complaint: 'url must match pattern "http(s)://*.*"'
          },
          // todo: illegal chars, consecutive periods, ...
        ],
      }
    },
    computed: {
      url: {
        get() {
          return this.fieldValue
        },
        set(val) {
          this.updateValue(val.trim())
        }
      }
    }
  }
</script>

<style scoped>
  .field {
    display: grid;
    grid-template-columns: 10rem auto;
  }
  input {
    width: 100%;
  }
</style>
